import React from "react";
import { Form, Button, Tab } from "react-bootstrap";
// _includes
import { common, history } from "_helpers";
// pages
import AccountList from "./AccountList";
import GroupList from "./GroupList";

class AdminUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.match.params.page,
    };
  }

  componentDidMount() {
    this.checkAccess();
  }

  setTab = (tab) => {
    this.setState({
      activeTab: tab,
    });
    history.push(tab);
  };

  // page access
  checkAccess() {
    const { activeTab } = this.state;
    let pageList = {
      account: "USERACCOUNT_PAGEACCESS",
      group: "USERGROUP_PAGEACCESS",
    };
    if (!common.isAccess(pageList[activeTab])) {
      common.accessDenied();
    } else {
      return true;
    }
  }

  render() {
    const { activeTab } = this.state;
    return (
      <div className="pageContent">
        <Tab.Container activeKey={activeTab}>
          <div className="contentHead">
            <div className="row">
              <div className="col-sm-5 poFlex">
                <h1>Users & Permissions</h1>
                <ul>
                  <li>
                    <a href="#">Users & Permissions</a>
                  </li>
                  <li>
                    <a href="#" className="noPipe">
                      Overview
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-sm-7">
                <Form className="poTabs poFlex poDefault">
                  {common.isAccess("USERACCOUNT_PAGEACCESS") && (
                    <Button
                      variant="primary"
                      className={activeTab != "account" ? "inActive" : ""}
                      onClick={() => this.setTab("account")}
                    >
                      Users
                    </Button>
                  )}
                  {common.isAccess("USERGROUP_PAGEACCESS") && (
                    <Button
                      variant="primary"
                      className={activeTab != "group" ? "inActive" : ""}
                      onClick={() => this.setTab("group")}
                    >
                      User Groups
                    </Button>
                  )}
                </Form>
              </div>
            </div>
          </div>
          <div className="contentBody">
            <div className="content">
              <Tab.Content>
                {common.isAccess("USERACCOUNT_PAGEACCESS") && (
                  <Tab.Pane eventKey="account" title="User">
                    <AccountList />
                  </Tab.Pane>
                )}
                {common.isAccess("USERGROUP_PAGEACCESS") && (
                  <Tab.Pane eventKey="group" title="User Group">
                    <GroupList />
                  </Tab.Pane>
                )}
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    );
  }
}
export { AdminUser };
